<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          d="M12 5.07601e-05C8.78788 0.0501698 5.72419 1.36113 3.47003 3.65005C2.34803 4.77189 1.46274 6.10763 0.866676 7.57804C0.270609 9.04846 -0.0240999 10.6236 2.75294e-05 12.2101C-0.00129007 13.7595 0.3031 15.2941 0.895762 16.7258C1.48842 18.1574 2.35771 19.4581 3.45384 20.5533C4.54996 21.6485 5.85139 22.5167 7.28356 23.1081C8.71574 23.6996 10.2505 24.0027 11.8 24.0001H12C15.2101 23.971 18.2773 22.6686 20.5275 20.379C22.7776 18.0895 24.0267 15.0001 24 11.7901C24.003 10.2232 23.6931 8.67146 23.0884 7.22593C22.4838 5.7804 21.5966 4.47015 20.4789 3.37202C19.3612 2.27388 18.0355 1.40997 16.5795 0.830942C15.1236 0.251915 13.5666 -0.0305709 12 5.07601e-05ZM10.5 16.5401C10.4919 16.339 10.5248 16.1384 10.5967 15.9505C10.6687 15.7626 10.7782 15.5914 10.9186 15.4472C11.059 15.3031 11.2273 15.1891 11.4132 15.1122C11.5992 15.0353 11.7988 14.9972 12 15.0001C12.3939 15.0023 12.7717 15.1564 13.0548 15.4302C13.338 15.704 13.5046 16.0765 13.52 16.4701C13.5281 16.6681 13.4961 16.8657 13.4258 17.051C13.3556 17.2364 13.2486 17.4056 13.1113 17.5485C12.974 17.6914 12.8092 17.8051 12.6268 17.8827C12.4444 17.9603 12.2482 18.0002 12.05 18.0001C11.6526 18.0057 11.2687 17.8564 10.9794 17.5839C10.6901 17.3114 10.5182 16.9371 10.5 16.5401ZM11 12.5401V6.54005C11 6.27483 11.1054 6.02048 11.2929 5.83294C11.4805 5.64541 11.7348 5.54005 12 5.54005C12.2652 5.54005 12.5196 5.64541 12.7071 5.83294C12.8947 6.02048 13 6.27483 13 6.54005V12.5401C13 12.8053 12.8947 13.0596 12.7071 13.2472C12.5196 13.4347 12.2652 13.5401 12 13.5401C11.7348 13.5401 11.4805 13.4347 11.2929 13.2472C11.1054 13.0596 11 12.8053 11 12.5401Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath>
        <rect
          width="24"
          height="24"
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
</template>
